import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { isChurchPublicPath } from "@/lib/church-public-routes";

const WEBSITE_ID = "dfid_YZ3mGVAHSE5Ffxqbc1WgF";
const DOMAIN = "ecclesiato.com.br";
const SCRIPT_ID = "datafast-script";

const readConsent = () => {
  try {
    return localStorage.getItem("ecclesiato-cookie-consent") === "accepted";
  } catch {
    return false;
  }
};

/**
 * Carrega o DataFast na versão que a LGPD permite para cada visitante.
 *
 * O script padrão grava um cookie para reconhecer quem volta (e atribuir
 * receita a campanhas de semanas atrás); sem aceite, isso não pode. Até
 * 28/09/2026 ele estava fixo no index.html e gravava o cookie em qualquer
 * página, antes de qualquer resposta ao aviso.
 *
 * - Site do Ecclesiato e painel, com "Aceitar": script com cookie.
 * - Páginas das igrejas (bio, formulários), e quem ainda não aceitou ou
 *   recusou: script sem cookie (script.cookieless.js). Não grava nada que
 *   dure — só a sessão da aba — e as metas de produto continuam chegando. O
 *   custo é o visitante ser "novo" a cada ~24h.
 *
 * Carrega uma vez por aba. Quem aceita depois de o script sem cookie já ter
 * entrado passa a ter o de cookie na próxima visita: trocar no meio contaria
 * a mesma pessoa duas vezes.
 */
export function DataFastLoader() {
  const { pathname } = useLocation();
  const [consent, setConsent] = useState(readConsent);

  useEffect(() => {
    const onChange = () => setConsent(readConsent());
    window.addEventListener("cookie-consent-updated", onChange);
    return () => window.removeEventListener("cookie-consent-updated", onChange);
  }, []);

  const churchPublic = isChurchPublicPath(pathname);

  useEffect(() => {
    if (document.getElementById(SCRIPT_ID)) return;
    const withCookie = consent && !churchPublic;
    const script = document.createElement("script");
    script.id = SCRIPT_ID;
    script.defer = true;
    script.dataset.websiteId = WEBSITE_ID;
    script.dataset.domain = DOMAIN;
    script.src = withCookie
      ? "https://datafa.st/js/script.js"
      : "https://datafa.st/js/script.cookieless.js";
    document.head.appendChild(script);
  }, [consent, churchPublic]);

  return null;
}
